import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {initialState} from '@/store/states/wallet'

export const slice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    CLEAR_WALLET: () => initialState,
    SET_HEXA: (state, {payload}: PayloadAction<number>) => {
      state.hexa = payload
    },
    SET_REEX: (state, {payload}: PayloadAction<number>) => {
      state.reex = payload
    },
    SET_OCTA: (state, {payload}: PayloadAction<number>) => {
      state.octa = payload
    },
    SET_ETHOS: (state, {payload}: PayloadAction<number>) => {
      state.ethos = payload
    },
    SET_HEPTA: (state, {payload}: PayloadAction<number>) => {
      state.hepta = payload
    },
    SET_TERRA: (state, {payload}: PayloadAction<number>) => {
      state.terra = payload
    },
    SET_DOMINION: (state, {payload}: PayloadAction<number>) => {
      state.dominion = payload
    },
    SET_WALLET: (
      state,
      {
        payload,
      }: PayloadAction<{
        hexa: number
        octa: number
        hepta: number
        reex: number
        ethos: number
        terra: number
        dominion: number
        loyalty: number
        onegm: number
      }>
    ) => {
      state.hepta = payload.hepta
      state.octa = payload.octa
      state.hexa = payload.hexa
      state.reex = payload.reex
      state.ethos = payload.ethos
      state.terra = payload.terra
      state.dominion = payload.dominion
      state.loyalty = payload.loyalty
      state.onegm = payload.onegm
    },
  },
})

export const {
  CLEAR_WALLET,
  SET_HEXA,
  SET_REEX,
  SET_OCTA,
  SET_ETHOS,
  SET_HEPTA,
  SET_TERRA,
  SET_DOMINION,
  SET_WALLET,
} = slice.actions

export default slice.reducer
